module.exports = __webpack_public_path__ + "assets/fonts/double-check-logo-bimedia.9bf3cce9.svg";